<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !text-[#21252A] !pl-[32px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info !text-[#343A40]"> Legal Compliance</span>
  </div>

  <div class="container p-5 !pl-0 !pt-0 !pb-0">
    <!--  Compliance and Legal Information  -->
    <div #container_wrapper id="container_wrapper" class="container_wrapper">
      <div
        class="container-fluid flex justify-center h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h3
            class="!text-[20px] !text-[#21252A] !font-semibold !mb-[0px] !pt-0 !pb-[22px]"
          >
            Legal Compliance
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="!mt-[6px] !mb-[19px] container pr-5">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center !w-full !h-[115px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                >
                  <label>
                    Have there been any regulatory actions or prosecutions
                    against your company in the last five (5) years?
                  </label>
                  <mat-radio-group
                    formControlName="has_prosecutions"
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-end mr-8"
                  >
                    <mat-radio-button value="1">Yes</mat-radio-button>
                    <mat-radio-button value="0">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="!mt-[6px] !mb-[19px] container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center !w-full !h-[115px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                >
                  <label>
                    Are you currently involved in any legal disputes related to
                    construction projects?
                    <br />If yes, provide details.
                  </label>
                  <mat-radio-group
                    formControlName="has_current_legal_dispute"
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-end mr-8"
                  >
                    <mat-radio-button value="1">Yes</mat-radio-button>
                    <mat-radio-button value="0">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <div
              class="container p-5 !pl-0 !pt-0 !pb-0 !mt-[29px]"
              *ngIf="formGroup.get('has_current_legal_dispute').value === '1'"
            >
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                  class="!w-full !h-[127px] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Provide Detail </mat-label>
                  <textarea
                    matInput
                    rows="4"
                    formControlName="current_legal_dispute_details"
                    placeholder="Provide Detail"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[20px] !text-[#21252A] font-semibold !mb-[0px] !pt-[12px] !pb-[22px]"
          >
            Legal Information
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="!mt-[6px] !mb-[19px] container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center !w-full !h-[115px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                >
                  <label>
                    Confirm your organisation adheres to anti-bribery,
                    anti-corruption, and ethical business practices.
                  </label>
                  <mat-radio-group
                    formControlName="confirm_business_practices"
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-end mr-8"
                  >
                    <mat-radio-button value="1">Yes</mat-radio-button>
                    <mat-radio-button value="0">No</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="container p-0 !pt-0 !pb-0 !mb-[41px]">
              <div class="rounded pr-[1.3rem] !pl-0 !pb-0 !pt-0">
                <div
                  class="!p-10 !pl-0 !pb-0 !pt-0  !text-[#21252A] items-center !w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1"
                >
                  <label>
                    Provide details of any accreditations related to ethical
                    practices (e.g., Ethical Trading Initiative):
                  </label>
                  <div class="bg-[#FFFFFF]">
                    <div
                      class="flex w-full h-[122px] flex-col items-center justify-center p-6 border-2  border-dashed border-gray-300 cursor-pointer transition-all duration-300 bg-[#F7F6FB] hover:bg-gray-100"
                    >
                      <!-- (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event, false)"
                    [class.bg-blue-50]="isDragging" -->
                  
                    <button
                    type="button"
                    class="bg-[#D9D9D9] text-[#21252A] px-4 py-2  hover:bg-[#F1F3F5] focus:outline-none"
                    (click)="fileInputDocument.click()"
                  >
                    Attach File
                  </button>
                      <p class="text-[14px] pt-[5px] !font-medium !m-0 !text-[#21252A]">
                        Drag & Drop
                      </p>


                      <input
                        type="file"
                        multiple
                        #fileInputDocument
                        (change)="
                          onFileUpload($event, 'ethical_practices_attach')
                        "
                        hidden
                      />
                    </div>
                  </div>
                  <!-- Old attachments -->

                  <div
                    class="flex flex-col"
                    *ngFor="
                      let file of oldEthicalPracticesAttachMents;
                      let i = index
                    "
                  >
                    <div class="flex items-start mt-[11px]">
                      <div class="flex justify-start items-center">
                        <div
                          class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
                        >
                          <img
                            [src]="getFileIcon(file)"
                            alt="File Preview"
                            class="object-cover w-auto h-[100%] cursor-pointer"
                          />
                        </div>
                      </div>

                      <span
                        style="
                          color: black;
                          text-align: left;
                          font-size: 18px;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          display: inline-block;
                          overflow: visible;
                          margin-left: 10px;
                          margin-top: 5px;
                        "
                      >
                        {{ file.title }}
                      </span>

                      <img
                        src="assets/icons/trash.svg"
                        alt="trash"
                        class="object-cover w-auto cursor-pointer ml-[8px] !mt-[11px] !h-[13px]"
                        (click)="
                          removeOldFile(i, file.id, 'ethical_practices_attach')
                        "
                      />
                    </div>
                  </div>
                  <!-- new attachments -->

                  <div
                    class="flex flex-col"
                    *ngFor="
                      let file of ethicalPracticesAttachMents;
                      let i = index
                    "
                  >
                    <div class="flex items-start mt-[11px]">
                      <div class="flex justify-start items-center">
                        <div
                          class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
                        >
                          <img
                            [src]="getFileIcon(file)"
                            alt="File Preview"
                            class="object-cover w-auto h-[100%] cursor-pointer"
                          />
                        </div>
                      </div>

                      <span
                        style="
                          color: black;
                          text-align: left;
                          font-size: 18px;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          display: inline-block;
                          overflow: visible;
                          margin-left: 10px;
                          margin-top: 5px;
                        "
                      >
                        {{ file.name }}
                      </span>

                      <img
                        src="assets/icons/trash.svg"
                        alt="trash"
                        class="object-cover w-auto cursor-pointer ml-[8px] !mt-[11px] !h-[13px]"
                        (click)="removeNewFile(i, 'ethical_practices_attach')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
